import { t } from "@/i18n-js/instance";
import { IconButton } from "@/react/components/shared/uikit/HeaderV3/IconButton";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { usePopoverPortalContext } from "./PopoverPortalContext";

export const Header = () => {
  const { onClose } = usePopoverPortalContext();

  return (
    <div className="border-primary flex w-full items-center justify-between border-b p-3">
      <Typography.BodyMd color="text-dark" weight="font-semibold">
        {t("color_picker_v2.color_picker")}
      </Typography.BodyMd>
      <IconButton
        name="16-close"
        buttonSize={24}
        iconSize={16}
        ariaLabel={t("close")}
        onClick={onClose}
      />
    </div>
  );
};
